// All bubbling events
// SEE: https://developer.mozilla.org/en-US/docs/Web/Events

const wait = 200 // the number of milliseconds to wait

export default {
  DOMContentLoaded: { wait },
  abort: { wait },
  animationcancel: { wait },
  animationend: { wait },
  animationiteration: { wait },
  animationstart: { wait },
  auxclick: { wait },
  change: { wait },
  click: { wait },
  compositionend: { wait },
  compositionstart: { wait },
  compositionupdate: { wait },
  contextmenu: { wait },
  copy: { wait },
  cut: { wait },
  dblclick: { wait },
  drag: { wait },
  dragend: { wait },
  dragenter: { wait },
  dragleave: { wait },
  dragover: { wait },
  dragstart: { wait },
  drop: { wait },
  error: { wait },
  focusin: { wait },
  focusout: { wait },
  fullscreenchange: { wait },
  fullscreenerror: { wait },
  hashchange: { wait },
  input: { wait },
  keydown: { wait },
  keyup: { wait },
  mousedown: { wait },
  mousemove: { wait },
  mouseout: { wait },
  mouseover: { wait },
  mouseup: { wait },
  paste: { wait },
  pointercancel: { wait },
  pointerdown: { wait },
  pointerlockchange: { wait },
  pointerlockerror: { wait },
  pointermove: { wait },
  pointerout: { wait },
  pointerover: { wait },
  pointerup: { wait },
  popstate: { wait },
  reset: { wait },
  scroll: { wait },
  select: { wait },
  submit: { wait },
  touchcancel: { wait },
  touchend: { wait },
  touchmove: { wait },
  touchstart: { wait },
  transitioncancel: { wait },
  transitionend: { wait },
  transitionrun: { wait },
  transitionstart: { wait },
  visibilitychange: { wait },
  wheel: { wait }
}
